import { SignIn } from "../pages/Auth/Signin";
import { BiltyList } from "../pages/BiltyList";
import { Cities } from "../pages/Cities";
import { FileExplorer } from "../pages/FileExplorer";
import { Company } from "../pages/Company";
import { CompanyDetail } from "../pages/CompanyDetail";
import Dashboard from "../pages/Dashboard";
import { Kyc } from "../pages/Kyc";
import { Load } from "../pages/Load";
import { LoadDetail } from "../pages/LoadDetail";
import { Pincodes } from "../pages/Pincodes";
import { Reports } from "../pages/Reports";
import { Shipper } from "../pages/Shipper";
import { States } from "../pages/States";
import { Support } from "../pages/Support";
import { Transporters } from "../pages/Transporters";
import { Trucks } from "../pages/Trucks";
import { TruckTypeDetail } from "../pages/TruckTypeDetail";
import { TruckTypes } from "../pages/TruckTypes";
import { Roles } from "../pages/Roles";
import { Users } from "../pages/Users";
import Permissions from "./permissions";
import { Lock } from "../pages/Auth/Lock";
import { ServerError } from "../pages/Auth/ServerError";
import { ResetPassword } from "../pages/Auth/ResetPassword";
import { NotFound } from "../pages/Auth/NotFound";
import { Forgot } from "../pages/Auth/ForgotPassword";
import { KycDocs } from "../pages/KycDocs";
import { KycSections } from "../pages/KycSections";
import { TruckKYC } from "../pages/TruckKYC";

export const Routess = {
    // Auth
    Login: { path: "/login", permission : null, component : <SignIn/> },
    Lock: { path: "/lock", permission : null, component : <Lock/> },
    NotFound: { path: "/not-found", permission : null, component : <NotFound/> },
    ResetPassword: { path: "/reset-password", permission : null, component : <ResetPassword/> },
    ServerError: { path: "/server", permission : null, component : <ServerError/> },
    Forgot: { path: "/forgot", permission : null, component : <Forgot/> },

    Home: { path: "/", permission : null, component : <Dashboard/> },
    DashboardOverview: { path: "/dashboard", permission : null, component : <Dashboard/> },
    Company: { path: "/company", permission : Permissions.Company.ViewCompany, component : <Company/> },
    CompanyDetail: { path: "/company/:id", permission : Permissions.Company.ViewCompany, component : <CompanyDetail/> },
    Shipper: { path: "/shipper", permission : Permissions.Shipper.View, component : <Shipper/> },
    Transporter: { path: "/transporter", permission : Permissions.Transporter.View, component : <Transporters/> },
    Truck: { path: "/trucks", permission : Permissions.Truck.ViewTrucks, component : <Trucks/> },
    TruckTypes: { path: "/truck-types", permission : Permissions.Truck.ViewTruckType, component : <TruckTypes/> },
    TruckTypeDetail: { path: "/truck-types/:id", permission : Permissions.Truck.ViewTruckType, component : <TruckTypeDetail/> },
    Kyc: { path: "/kyc", permission : Permissions.KYC.RequestView, component : <Kyc/> },
    TruckKyc: { path: "/truck-kyc", permission : Permissions.KYC.RequestView, component : <TruckKYC/> },
    KycDocs: { path: "/kyc-docs", permission : Permissions.KYC.DocumentView, component : <KycDocs/> },
    KycSections: { path: "/kyc-sections", permission : Permissions.KYC.SectionView, component : <KycSections/> },
    Loads: { path: "/loads", permission : Permissions.Load.View, component : <Load/> },
    LoadDetail: { path: "/loads/:id", permission : Permissions.Load.View, component : <LoadDetail/> },
    Bilty: { path: "/bilty", permission : Permissions.Bilty.View, component : <BiltyList/> },
    States: { path: "/states", permission : Permissions.Pincode.View, component : <States/> },
    Cities: { path: "/states/:stateid", permission : Permissions.Pincode.View, component : <Cities/> },
    Pincodes: { path: "/states/:stateid/:cityid", permission : Permissions.Pincode.View, component : <Pincodes/> },
    Reports: { path: "/reports", permission : null, component : <Reports/> },
    Support: { path: "/support", permission : null, component : <Support/> },
    User: { path: "/crm-users", permission : Permissions.Users.View, component : <Users/> },
    UserGroup: { path: "/role-permissions", permission : Permissions.Roles.View, component : <Roles/> },

    
    
    Cloud: { path: "/file-explorer", permission : Permissions.FileExplorer.View, component : <FileExplorer/> },
};